// const apiURL = "https://cryptotradeapi.solvyxx.com";
const apiURL = "https://api-min.versetrade.tech";
// const apiURL = "http://localhost:9000";
const API_BASE_URL = `${apiURL}/api/v1`;

export { apiURL, API_BASE_URL };
